/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

export function useIdle(callback: () => void) {
	useEffect(() => {
		const onIdle = (fn: () => void) => {
			if ('scheduler' in window) {
				return (window as any).scheduler.postTask(fn, {
					priority: 'background',
				});
			}
			if ('requestIdleCallback' in window) {
				return requestIdleCallback(fn);
			}
			setTimeout(fn, 0);
		};

		onIdle(callback);
	}, [callback]);
}
